define('bizzabo/views/popup/EditSpeakerView',[
    'jquery',
    'backbone',
    'underscore',
    'bizzabo/utils',
    'bizzabo/consts',
    'bizzabo/views/FormMixin',
    'bizzabo/views/ModelBindingMixin',
    'bizzabo/views/popup/PopupView',
    'bizzabo/views/UploadFileView',
    'bizzabo/bzapi',
    'hbars!bizzabo/templates/editSpeaker',
    'hbars!bizzabo/templates/speakerResult',
    'bizzabo/config',
    'bizzabo/views/UploadFileCloudinaryView',
    'bizzabo/models/Auth',
    'bizzabo/models/Global'
], function(
    $,
    Backbone,
    _,
    UTILS,
    Consts,
    FormMixin,
    ModelBindingMixin,
    PopupView,
    UploadFileView,
    BZAPI,
    template,
    speakerTemplate,
    CONFIG,
    UploadFileCloudinaryView,
    Auth,
    Global
    ) {

    var EditSpeakerView = PopupView.extend({

        events : {
            'click .doneButton' : 'doneClicked',
            'click .cancelButton' : 'cancelClicked',
            'keydown .doneButton' : 'doneKeyClicked',
            'keydown .cancelButton' : 'cancelKeyClicked',
            'keyup input' : 'toggleDoneButton',
            'click .connect-with-linkedin' : 'connectLinkedInClicked',

            //autocomplete events
            'autocompleteselect input[name="speakersearch"]' : "formSpeakerSelected"
        },

        disableChosen : true,
        keyPressValidationFields : ["first-name", "last-name", "title", "company"],
        modelBindingBlackList : ['photo-url', 'client-id'],
        modelBindingWhiteList : ['country'],
        bindAllValidationFields : true,

        editSessionView : undefined,

        initialize : function() {
            this.popUpInitialize();
            this.editSessionView = this.options.editSessionView;
            UTILS.mixIntoMe(this, FormMixin); // mixin standard form & validation
            UTILS.mixIntoMe(this, ModelBindingMixin); // mixin model binding

            _.bindAll(this, 'renderAutoCompleteList');

            this.modelSnapshot = this.model ? this.model.toJSON() : {};

            // Bind model changes to form
            this.model.on('change:photo-url', this.renderPhoto, this);
            //this.model.on('change:country', this.render, this);

            this.initModelBinding();
            this.initValidation(true);
            this.initializeUploadCloudinaryView();

            this.model.on("validated:valid", this.modelValid, this);
            this.model.on("validated:invalid", this.modelInvalid, this);
            this.model.on(Consts.Notifications.validation.KEY_PRESS_VALIDATION + ":valid", this.modelKeyPressValid, this);
            this.model.on(Consts.Notifications.validation.KEY_PRESS_VALIDATION + ":invalid", this.modelKeyPressInvalid, this);
        },

        initializeUploadCloudinaryView : function() {
            this.cloudinary = new UploadFileCloudinaryView({
                cropping: 'server',
                smallButton: true,
                cropping_aspect_ratio: 1,
                max_image_width: 500,
                max_image_height: 500,
                recommendedSize: 'Recommended image size: 500W X 500H. Must be JPG, GIF, or PNG and smaller than 750Kb'
            });
            this.listenTo(this.cloudinary, 'success', this.renderImage);
        },

        remove : function() {
            this.model.off("validated:valid", this.modelValid, this);
            this.model.off("validated:invalid", this.modelInvalid, this);
            this.model.off(Consts.Notifications.validation.KEY_PRESS_VALIDATION + ":valid", this.modelKeyPressValid, this);
            this.model.off(Consts.Notifications.validation.KEY_PRESS_VALIDATION + ":invalid", this.modelKeyPressInvalid, this);

            this.model.validate();

            this.removeModelBinding();
            this.removeValidation();

            // Unbind model changes from form
            this.model.off('change:photo-url', this.renderPhoto, this);

            // Remove subviews
            this.cloudinary.remove();
            this.popupRemove();
        },

        initSpeakerAutoComplete : function() {
            var xxx = _.debounce(BZAPI.getSpeakers, 1500);

            var thisView = this;
            this.input = this.$('input[name=speakersearch]');
            this.input.autocomplete({
                source : function(termObject, cb) {
                    thisView.$('.speaker-spinner').toggleClass('rollIn', true);
                    var success = function(speakers) {
                        speakers = UTILS.ensureArray(speakers);
                        _.each(speakers, function(speaker){
                           speaker.value = speaker['first-name'] + ' ' + speaker['last-name'];
                        });

                        if (speakers.length === 0) {
                            speakers.push({
                                'empty': 'true'
                            });
                        }
                        if (cb) {
                            cb(speakers);
                        }
                    };

                    xxx(termObject.term, success);
                },
                minLength : 2,
                delay : 100,
                autoFocus : true,
                appendTo : null
            });

            this.input.data( "ui-autocomplete")._renderMenu = this.renderAutoCompleteList;

            this.input.bind('paste', function () {
                setTimeout(function() {
                    thisView.input.autocomplete('search', thisView.input.val());
                }, 0);
            });
        },

        renderAutoCompleteList : function( ul, items ) {
            var thisInput = this.input;
            $(ul).addClass('ui-autocomplete-speakers');
            this.$('.speaker-spinner').toggleClass('rollIn', false);
            if (items.length == 1 && items[0].empty) {
                $('<li>').addClass('autocomplete-list-item empty').html("No Results :-(").appendTo(ul);
                return;
            }

            items = items.reverse();
            if (_.findWhere(items, {source: "BIZZABO"})) {
                $('<li>').addClass('bizzabo-header').html("Bizzabo's Directory Results").appendTo(ul);
            }
            if (_.findWhere(items, {source: "LINKEDIN"})) {
                $('<li>').addClass('linkedin-header').html("Linkedin Results").appendTo(ul);
            }

            thisInput._renderItemData = function( ul, item ) {
                var li = speakerTemplate(item);

                li = $(li).data( "ui-autocomplete-item", item );

                if (item.source == "BIZZABO") {
                    return $('.bizzabo-header').after( li );
                }
                return $('.linkedin-header').after( li );

            };
            _.each( items, function(item) {
                thisInput._renderItemData( ul, item );
            });
        },

        // Actions

        connectLinkedInClicked : function() {
            var thisView = this;
            var auth = Global.modelPool.getAuth();
            auth.connectWithLinkedin({
                success: function() {
                    thisView.render();
                },
                error: function() {
                    window.alert("Error connecting Linkedin.");
                }
            });
        },

        formSpeakerSelected : function(event, ui) {
            if (ui.item.id) {
                delete ui.item.id;
            }

            //trim @ if exist
            if (ui.item['twitter-handle'] !== undefined) {
                ui.item['twitter-handle'] = ui.item['twitter-handle'].indexOf('@') != -1 ? ui.item['twitter-handle'].substring(1) : ui.item['twitter-handle'] ;
            }

            var speakerId = this.model.get('id');
            this.model.clear();
            this.model.set(ui.item);
            this.model.set('id', speakerId);
        },

        formCountryChanged : function() {
            var value = this.$('#speaker-country').val();
            if(value.length === 0) {
                this.model.unset('country');
            } else {
                this.model.set('country', value);
            }
        },

        cancelClicked : function() {
            this.removeValidation();
            this.revertModelToSnapshot();
            this.model.validate();

            if (this.options.cancelCb) {
                this.options.cancelCb();
            }
            this.hide();
        },

        revertModelToSnapshot : function() {
            var oldKeys = _.keys(this.modelSnapshot);
            var newKeys = _.keys(this.model.attributes);
            var diff = _.difference(newKeys, oldKeys);

            this.model.set(this.modelSnapshot);
            for (var i = 0; i < diff.length; i++) {
                this.model.unset(diff[i]);
            }
        },

        cancelKeyClicked : function(e) {
            var ev = e || event;
            if (ev.keyCode == 13) {
                this.cancelClicked();
                return false;
            }
        },

        doneClicked : function() {
            if (!this.model.isValid(true)) {
                return;
            }
            if (this.options.doneCb) {
                this.options.doneCb();
            }

            this.replaceImageIfNeeded();
            this.hide();
        },

        doneKeyClicked : function(e) {
            var ev = e || event;
            if (ev.keyCode == 13) {
                this.doneClicked();
                return false;
            }
        },

        replaceImageIfNeeded : function() {
            var thisView = this;
            var photoUrl = this.model.get('photo-url');
            if (photoUrl && photoUrl.length > 0) {
                if (this.model.get('photo-url').indexOf('bizzabo') == -1) {
                    BZAPI.replaceImageURL(this.model.get('photo-url'), function(location) {
                        thisView.model.set('photo-url', location);
                    }, {}, 'thumbnail');
                }
            }
        },


        // Edit Photo
        renderImage: function () {
            this.model.set('photo-url', this.cloudinary.image);
            this.replaceImageIfNeeded();
        },


        startSearch : function() {
            if (this.model.get('newSpeaker') === true) {
                var fullName = this.model.get('first-name') + ' ';
                fullName += this.model.get('last-name') ? this.model.get('last-name') : '';
                this.$('input[name="speakersearch"]').val(fullName);
                this.$('input[name="speakersearch"]').autocomplete("search", fullName);
                //TODO : Fix the focus bug
                window.setTimeout(function() {
                    this.$("input[name='speakersearch']").focus();
                }, 1000);
            }

        },

        // View Rendering
        renderToolTips : function() {
            this.$('[data-toggle="tooltip"]').tooltip({
                placement : 'right'
            });
        },

        renderPhoto : function() {
            var hasPhoto = (this.model.has('photo-url') && this.model.get('photo-url').length > 0);
            var photoURL = hasPhoto ? this.model.get('photo-url') : 'images/agenda/avatar_5.jpg';

            this.$('.eventLogoBox').toggleClass('hasLogo', hasPhoto);
            this.$('.speakerPhoto').attr('src', photoURL);
        },

        renderSubViews : function() {
            this.$('.eventLogoBox').html(this.cloudinary.render().el);
            this.$('.uploadFile').addClass('edit-speaker-upload');
        },

        render : function() {
            var jsonModel = this.model ? this.model.toJSON() : {};
            if (!Global.modelPool.getMe().get('external-ids-linkedin')) {
                jsonModel.notWithLinkedin = true;
            }
            var html = template(jsonModel);
            this.$el.html(html);
            this.$el.addClass('edit-speaker-wrapper');
            this.initSpeakerAutoComplete();
            this.renderSubViews();
            this.renderPhoto();
            this.renderToolTips();
            this.startSearch();
        },

        viewRendered : function() {
            this.renderForm();
        }
    });

    return EditSpeakerView;

});
